<template>
  <div>
    <Alert ref="alert"/>
    <Loader ref="loader"/>
    <router-view/>
  </div>
</template>

<script>
import Alert from "@/components/Alert";
import { EventBus } from "@/services/event-bus.js";
import Loader from "@/components/Loader";

export default {
  name: "App",
  data() {
    return {
      selectedClients: []
    };
  },
  components: { Alert, Loader },
  created: function() {
  },
  mounted: function() {
    EventBus.$on("triggerAlert", options => {
      this.triggerAlert(options);
    });
    EventBus.$on("showLoader", () => {
      this.showLoader();
    });
    EventBus.$on("hideLoader", () => {
      this.hideLoader();
    });
  },
  methods: {
    triggerAlert(options) {
      this.$refs.alert.showAlert(options);
    },
    showLoader() {
      this.$refs.loader.showLoader();
    },
    hideLoader() {
      this.$refs.loader.hideLoader();
    }
  }
};
</script>

<style lang="scss">
@import "../node_modules/bootstrap/scss/bootstrap.scss";
</style>



// WEBPACK FOOTER //
// src/App.vue